export const experiences = [
  {
    position: 'Freelance Software Engineer | Philippines',
    timeline: 'Mar 2020 - Jun 2021',
    details: 'Clients: The Rolls Kitchen, The Busy Bee, Soren Apparel',
    description: [
      'Partnered directly with business owners and executives to translate business objectives into scalable web application solutions.',
      'Designed and developed end-to-end e-commerce platforms spanning customer-facing experiences and administrative management systems.',
      'Architected application databases and backend systems with a focus on maintainability, scalability, and long-term growth.'
    ]
  },
  {
    company: 'Dragonpay Corporation | Philippines',
    position: 'Freelance Software Engineer',
    timeline: 'Jun 2021 - Jul 2021',
    details: 'Leading Philippine payment gateway enabling digital payments across banks and payment channels.',
    description: [
      'Developed and deployed an internal employee wellness platform, streamlining organizational health tracking and reporting.',
      'Engineered an internal expense management application that automated financial workflows and improved operational efficiency for the finance team.'
    ]
  },
  {
    company: 'Philippine Red Cross | Philippines',
    position: 'Software Engineer',
    timeline: 'Jul 2021 - Oct 2021',
    details: 'Humanitarian organization providing emergency, healthcare, and disaster response services.',
    description: [
      'Developed automated module-level testing scripts to improve software reliability, maintainability, and deployment confidence.'
    ]
  },
  {
    company: 'Dashlabs.ai | Philippines',
    position: 'Software Engineer',
    timeline: 'Dec 2020 - Dec 2021',
    details: 'Y-Combinator healthtech startup building clinical analytics and healthcare software solutions.',
    description: [
      'Led and mentored a team of seven software engineers, providing technical leadership, architectural guidance, and code reviews for healthcare analytics solutions.',
      'Collaborated with medical professionals and cross-functional stakeholders to translate complex clinical requirements into scalable analytical software.',
      'Delivered over 30 production features that streamlined healthcare workflows and improved operational efficiency for medical professionals.',
      'Engineered over 20 interactive analytics dashboards and architected data aggregation pipelines that transformed complex healthcare datasets into actionable insights and meaningful visualizations for medical professionals.'
    ]
  },
  {
    company: 'SUTD campusX | Singapore',
    position: 'Software Engineer',
    timeline: 'Jan 2023 - Dec 2023',
    details: 'University research initiative developing a human-centric cyber-physical learning environment.',
    description: [
      'Collaborated with university faculty and cross-functional stakeholders to architect and deliver an AI-powered learning platform enhancing educational workflows and student engagement.',
      'Engineered a modular application framework configurable for multiple university courses.',
      'Defined the application\'s system architecture and relational database design, emphasizing scalability, maintainability, and long-term extensibility.'
    ]
  },
  {
    company: 'Procter & Gamble (P&G) | Singapore',
    position: 'Technical Lead and Software Engineer',
    timeline: 'May 2023 - Aug 2023',
    details: 'Academic Client Partnership | Consumer Analytics & Data Visualization Platform',
    description: [
      'Led a team of six engineers to deliver a data visualization platform supporting consumer behavior analysis for P&G\'s R&D organization.',
      'Engineered automated CSV ingestion and processing pipelines that transformed raw datasets into interactive analytical visualizations.',
      'Developed interactive dashboards enabling researchers to compare multi-dimensional datasets through configurable timelines, charts, and visual analytics.',
      'Designed consumer journey visualization features that uncovered behavioral trends and supported data-driven product decisions.',
      'Integrated AI-powered image analysis techniques to extract visual attributes and emotional signals from consumer-submitted images, enabling deeper product evaluation and research insights.'
    ]
  },
  {
    company: 'Jublia | Singapore',
    position: 'Software Engineer',
    timeline: 'Aug 2023 - Dec 2023',
    details: 'Event technology company providing platforms for event management, networking, and attendee engagement.',
    description: [
      'Redesigned a user-centric dashboard experience, improving usability and application navigation.',
      'Modernized a legacy Vue.js application by refactoring reusable components into a modular, maintainable architecture that improved scalability.',
      'Automated database integrity validation through scheduled monitoring scripts, improving operational reliability and reducing manual verification efforts.'
    ]
  },
  {
    company: 'Development Bank of Singapore (DBS) | Singapore',
    position: 'Team Lead and Software Engineer',
    timeline: 'Jan 2024 - May 2024',
    details: 'Academic Client Partnership | Queue Simulation & Operational Planning Platform',
    description: [
      'Led a team of five engineers to develop a configurable web-based queue simulation platform supporting operational planning across banking branches.',
      'Architected a scalable and modular system design that enabled flexible simulation scenarios and future platform extensibility.'
    ]
  },
  {
    company: 'Urban Redevelopment Authority (URA) | Singapore',
    position: 'Team Lead and Software Engineer',
    timeline: 'Sept 2024 - Dec 2024',
    details: 'Academic Client Partnership | AI-Powered Public Engagement Platform',
    description: [
      'Led a team of four engineers to architect and deliver an AI-powered public engagement platform that transformed user ideas into AI-generated visual concepts.',
      'Integrated advanced generative AI techniques, including prompt engineering and image inpainting, to improve image quality and user experience.',
      'Designed a configurable, modular application architecture enabling administrators to customize engagement workflows without code changes.',
      'Translated UX designs into production-ready software while ensuring consistency between design specifications and implementation.'
    ]
  },
  {
    company: 'Moya | Singapore',
    position: 'Software Engineer',
    timeline: 'Oct 2024 - Mar 2025',
    details: 'Climate technology startup developing data-driven solutions for emissions reduction and energy research.',
    description: [
      'Engineered automated data processing pipelines to aggregate, transform, and consolidate large CSV datasets into standardized analytical outputs and master datasets.',
      'Designed reusable scripts to generate abatement curves and analytical datasets, improving data processing efficiency and consistency.'
    ]
  },
  {
    company: 'Liminal | Singapore',
    position: 'AI Software Engineer',
    timeline: 'Jan 2025 - Apr 2025',
    details: 'Temasek-backed venture capital.',
    description: [
      'Engineered a production-ready full-stack multi-agent AI platform enabling configurable workflows, dynamic query execution, and customizable result management.',
      'Developed a responsive React-based chat interface featuring editable tables, configurable schemas, and real-time data visualization to improve user productivity.',
      'Architected a modular backend platform integrating multiple LLM providers, prompt engineering strategies, and extensible AI workflows for scalable feature development.'
    ]
  },
  {
    company: 'Xweave.io | Singapore',
    position: 'Software Engineer',
    timeline: 'May 2025 - Present',
    details: 'Fintech building blockchain-powered infrastructure for cross-border payments.',
    description: [
      'Architected and delivered secure integrations with multiple digital asset exchange providers, enabling scalable cross-border payment orchestration through standardized REST APIs.',
      'Designed and productionized an event-driven webhook architecture to provide reliable, real-time transaction synchronization across distributed payment systems.',
      'Architected and implemented a modular mid-market rate service using object-oriented design principles, enabling efficient retrieval, persistence, and synchronization of fiat and cryptocurrency exchange rates.',
      'Led and mentored two software engineers through technical guidance, code reviews, and architectural discussions, improving engineering quality and delivery velocity.'
    ]
  }
];
